// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';

const S = {
  ListBox: styled.div`
    overflow: auto;
    width: 100%;
    flex-grow: 1;
    display:flex;
    flex-direction: column;
  `,
  Tag: styled.div`
    font-size: 12px;
    line-height: 12px;
    color: #4DAB3D;
    align-items: center;
    text-align: center;
    display: flex;
  `,
  Image: styled.img`
    height: 15px;
    width: 15px;
    margin-left: 28px;
    margin-right: 6px;
  `,
  SidebarWrapper: styled.div`
    display: flex;
    flex-direction: column;
    max-width: 338px;
    flex-grow : 1 ;
    background: #FFFFFF;
    border-radius: 4px;
    filter: drop-shadow(0px 1px 6px rgba(0, 0, 0, 0.161));
  `,
  HeaderSidebar: styled.div`
    font-weight: bold;
    font-size: 18px;
    line-height: 26px;
    display: flex;
    align-items: center;
    color: #434343;
    background: #EFEFEF;
    width: 100%;
    height: 54px;
    padding: 14px 59px 14px 18px;
  `,
  BoxItem: styled.div<{ open?: boolean }>`
    position: relative;
    border-bottom: 1px solid #DEDEDE;
    max-height: 100px;
    flex-grow: 1;
    ${props => props.open ? `
      padding: 14px 18px 14px 10px;
      border-left: 8px solid #EF8200;
    `: `
      padding: 14px 18px 14px 18px;
    `}
    cursor: pointer;
  `,
  ItemTitle: styled.div<{ open?: boolean }>`
    font-size: 16px;
    line-height: 23px;
    ${props => props.open ? `
      color: #EF8200;
    `: `
      color: #434343;
    `}
    margin-bottom: 6px;
  `,
  ItemTime: styled.div`
    font-size: 12px;
    line-height: 17px;
    color: #848484;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  `,
  Read: styled.img`
    position: absolute;
    right: 0px;
    top:0;
  `
};

export { S as default };
